import { SIMULATION_STATUSES } from '../config';

type MapStatuses = (status: SIMULATION_STATUSES) => string;

export const mapStatuses: MapStatuses = (status) => {
  switch (status) {
    case SIMULATION_STATUSES.AWAITING_UW_DECISION:
      return 'Awaiting underwriting decision';
    case SIMULATION_STATUSES.AWAITING_OFFERS_DECISION:
      return 'Awaiting offers decision';
    case SIMULATION_STATUSES.AWAITING_KYC_DECISION:
      return 'Awaiting KYC decision';
    case SIMULATION_STATUSES.AWAITING_CONTRACT_SIGNING:
      return 'Awaiting contract signing';
    case SIMULATION_STATUSES.REJECTED:
      return 'Rejected';
    case SIMULATION_STATUSES.COMPLETED:
      return 'Completed';
    case SIMULATION_STATUSES.APPLICATION_IN_PROGRESS:
      return 'Application is in progress';
    case SIMULATION_STATUSES.AWAITING_ADDITIONAL_INFO:
      return 'Awaiting additional information';
    case SIMULATION_STATUSES.KYC_IN_PROGRESS:
      return 'KYC in progress';
    case SIMULATION_STATUSES.AWAITING_ADDITIONAL_KYC_INFO:
      return 'Awaiting additional KYC information';
    case SIMULATION_STATUSES.CLOSED:
      return 'Closed';
    default:
      return status;
  }
};
